import {fork} from 'redux-saga/effects'
import {showSaga} from './show'
import {updateSaga} from './update'

export function* organizationSaga() {
  yield fork(showSaga)
  yield fork(updateSaga)
}
